import { Box, Center, HStack, VStack } from "@chakra-ui/react";
import type { ComponentProps } from "react";
import ImageSlider from "./ImageSlider";

export const FormWrapper = ({ children }: ComponentProps<any>) => (
  <VStack
    spacing={8}
    minW={"80%"}
    as="form"
    w="full"
    align="flex-start"
    justify="flex-start"
  >
    {children}
  </VStack>
);

export const StepWithSlider = ({ color, children }: ComponentProps<any>) => (
  <HStack w="full" align="stretch" h="full">
    <Box
      flex="1"
      w="30%"
      top="100px"
      display={["none", "none", "none", "block"]}
    >
      <ImageSlider color={color} />
    </Box>
    <Box
      flex="2"
      h="full"
      w={["full", "full", "full", "70%"]}
    >
      <Center
        flex="1"
        w="full"
        py={[8, 8, 10]}
        px={[6, 8, 12]}
      >
        {children}
      </Center>
    </Box>
  </HStack>
);

export const StepWithoutSlider = ({ children }: ComponentProps<any>) => (
  <Box py={[8, 8, 10]} px={[8, 8, 10, 12]} flexGrow={1}>
    {children}
  </Box>
);
